export const listAllProducts = {
  page: 'listAllProductsPage',
  limit: 'listAllProductsLimit',
  scrollPosition: 'listAllProductsScrollPosition',
  search: 'listAllProductsSearch',
  filterCategories: 'listAllProductsFilterCategories',
  filterProductState: 'listAllProductsFilterProductState',
  filterByUnit: 'listAllProductsFilterByUnit'
}

export const listProductDetails = {
  page: 'listProductDetailsPage',
  limit: 'listProductDetailsLimit',
  filterInventory: 'listProductDetailsFilterInventory',
  filterInventoryName: 'listProductDetailsFilterInventoryName',
  currentTab: 'listProductDetailsCurrentTab',
  filterStartDate: 'listOrdersDeliveryFilterStartDate',
  filterEndDate: 'listOrdersDeliveryFilterEndDate'
}

export const listGoodsRequest = {
  page: 'listGoodsRequestPage',
  limit: 'listGoodsRequestLimit',
  currentTab: 'listGoodsRequestCurrentTab',
  scrollPosition: 'listGoodsRequestScrollPosition',
  search: 'listGoodsRequestSearch'
}

export const listOrdersDelivery = {
  page: 'listOrdersDeliveryPage',
  limit: 'listOrdersDeliveryLimit',
  currentTab: 'listOrdersDeliveryCurrentTab',
  scrollPosition: 'listOrdersDeliveryScrollPosition',
  search: 'listOrdersDeliverySearch',
  filterStartDate: 'listOrdersDeliveryFilterStartDate',
  filterEndDate: 'listOrdersDeliveryFilterEndDate'
}

export const listInventory = {
  page: 'listInventoryPage',
  limit: 'listInventoryLimit',
  scrollPosition: 'listInventoryScrollPosition',
  search: 'listInventorySearch',
  filterProductState: 'listInventoryFilterProductState',
  filterExpiryPeriod: 'listInventoryFilterExpiryPeriod'
};

export const listAdvertisement = {
  page: 'listAdvertisementPage',
  limit: 'listAdvertisementLimit',
  currentTab: 'listAdvertisementCurrentTab',
  scrollPosition: 'listAdvertisementScrollPosition',
};

export const listInterTransferOrder = {
  page: 'listInterTransferPage',
  limit: 'listInterTransferLimit',
  currentTab: 'listInterTransferCurrentTab',
  scrollPosition: 'listInterTransferScrollPosition',
  search: 'listInterTransferSearch',
  filterStartDate: 'listInterTransferFilterStartDate',
  filterEndDate: 'listInterTransferFilterEndDate'
}
export const warehouse = {
  warehouseRef: 'defaultWarehouse'
}
export const authStorage = {
  showSupplierRegistrationWelcome: 'showSupplierRegistrationWelcome',
}
export const listPurchaseOrder = {
  page: 'listPurchaseOrderPage',
  limit: 'listPurchaseOrderLimit',
  currentTab: 'listPurchaseOrderCurrentTab',
  scrollPosition: 'listPurchaseOrderScrollPosition',
  search: 'listPurchaseOrderSearch',
  filterStartDate: 'listPurchaseOrderFilterStartDate',
  filterEndDate: 'listPurchaseOrderFilterEndDate',
  category: 'listPurchaseOrderCategory',
  subCategory: 'listPurchaseOrderSubCategory',
  groupCategory: 'listPurchaseOrderGroupCategory',
};

export const listGoodsInWarehouse = {
  page: 'listGoodsInWarehousePage',
  limit: 'listGoodsInWarehouseLimit',
  scrollPosition: 'listGoodsInWarehouseScrollPosition',
  search: 'listGoodsInWarehouseSearch',
  filterVendor: 'listGoodsInWarehouseFilterVendor',
  filterVendorData: 'listGoodsInWarehouseFilterVendorData',
  filterProductState: 'listGoodsInWarehouseFilterProductState',
  filterExpiryPeriod: 'listGoodsInWarehouseFilterExpiryPeriod',
  filterBylastDays: 'listGoodsInWarehouseFilterByLastDays',
  removedVariant: 'listGoodsInWarehouseRemovedVariant',
  inventoryView: 'listGoodsInWarehouseInventoryView',
};

export const listLowStock = {
  page: 'listLowStockPage',
  limit: 'listLowStockLimit',
  scrollPosition: 'listLowStockScrollPosition',
};

export const listLowStockList = {
  page: 'listLowStockListPage',
  limit: 'listLowStockListLimit',
  scrollPosition: 'listLowStockListScrollPosition',
  search: 'listLowStockListSearch',
  filterSeller: 'listLowStockListFilterSeller',
  filterSellerData: 'listLowStockListFilterSellerData',
  filterProductState: 'listLowStockListFilterProductState',
  filterExpiryPeriod: 'listLowStockListFilterExpiryPeriod',
  filterBylastDays: 'listLowStockListFilterByLastDays',
  removedVariant: 'listLowStockListRemovedVariant',
};

export const listCategories = {
  page: "listCategoriesPage",
  limit: "listCategoriesLimit",
  scrollPosition: "listCategoriesScrollPosition",
  search: "listCategoriesSearch",
};

export const listBrands = {
  page: 'listBrandsPage',
  limit: 'listBrandsLimit',
  scrollPosition: 'listScrollPosition',
  search: 'listBrandsSearch',
};

export const listSupplierLedger = {
  page: 'listSupplierLedgerPage',
  limit: 'listSupplierLedgerLimit',
  scrollPosition: 'listSupplierLedgerScrollPosition',
  search: 'listSupplierLedgerSearch',
  filterStartDate: 'listSupplierLedgerFilterStartDate',
  filterEndDate: 'listSupplierLedgerFilterEndDate',
};
export const listVariants = {
  page: 'listVariantsPage',
  limit: 'listVariantsLimit',
  currentTab: 'listVariantsCurrentTab',
  currentTabId: 'listVariantsCurrentTabId',
  scrollPosition: 'listVariantsScrollPosition',
};
export const listMasterProducts = {
  page: 'listMasterProductsPage',
  limit: 'listMasterProductsLimit',
  scrollPosition: 'listMasterProductsScrollPosition',
  search: 'listMasterProductsSearch',
  filterProductState: 'listMasterProductsFilterProductState',
  filterCategories: 'listMasterProductsFilterCategories',
};

export const listMasterProductDetails = {
  currentTab: 'listMasterProductDetailsCurrentTab'
}

export const listEscalations = {
  page: 'listEscalationsPage',
  limit: 'listEscalationsLimit',
  search: 'listEscalationsSearch',
  currentTab: 'listEscalationsCurrentTab',
};